const EXACT_ISSUE_KEY_JQL =
	/^(?:key|issuekey)\s*=\s*(?:"([a-z][a-z0-9_]*-\d+)"|([a-z][a-z0-9_]*-\d+))\s*$/i;

/**
 * Converts a Jira issue navigator URL to the equivalent single-issue URL only
 * when its JQL proves that exactly one issue key was requested. Broader JQL is
 * deliberately left untouched: resolving it must never expand a search result
 * into an unbounded set of linked entities.
 *
 * The returned URL keeps the original origin, so ORS still resolves the issue
 * in the source tenant and applies its normal viewer permission checks.
 */
export const toJiraIssueResolutionUrl = (value: string): string => {
	let url: URL;
	try {
		url = new URL(value);
	} catch {
		return value;
	}

	if (url.protocol !== 'https:' || (url.pathname !== '/issues' && url.pathname !== '/issues/')) {
		return value;
	}

	const jql = url.searchParams.get('jql');
	const match = jql?.match(EXACT_ISSUE_KEY_JQL);
	const issueKey = match?.[1] ?? match?.[2];
	if (!issueKey) {
		return value;
	}

	return new URL(`/browse/${issueKey.toUpperCase()}`, url.origin).toString();
};
